import React from 'react';
import { Page } from '../components/ui/Page';
import { ShippingOrderWizard } from '../features/shipping/components/ShippingOrderWizard';

const ShippingOrderPage: React.FC = () => {
  return (
    <Page width="narrow">
      <ShippingOrderWizard />
    </Page>
  );
};

export default ShippingOrderPage;
